import React from 'react';
// MUI Theme
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { makeStyles } from '@mui/styles';

// Redux
import { SettingsState } from '../../../../redux/slices/settingsSlice';

import { PairingVerification } from '../../../../constants/Constants';
import FormInputCollection from '../../../common/FormInputCollection/FormInputCollection';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '5px',
    marginTop: '4px',
  },
  toggleButtonGroup: {
    height: '40px',
    backgroundColor: 'white',
  },
  toggleButton: {
    '&.MuiToggleButton-root': {
      fontSize: 'x-small',
      whiteSpace: 'nowrap',
    },
  },
}));
interface PairingVerificationStatusTabsProps {
  pairingStatusToggles: number[];
  settingStates: SettingsState;
  handlePairingStatusToggle: (event: React.MouseEvent<HTMLElement>, newValues: number[]) => void;
}
const PairingVerificationStatusTabs: React.FC<PairingVerificationStatusTabsProps> = React.memo(
  ({ pairingStatusToggles, settingStates, handlePairingStatusToggle }) => {
    const classes = useStyles();
    return (
      <div className={classes.container}>
        <FormInputCollection label={`${PairingVerification.PairingVerificationStatus}`}>
          <ToggleButtonGroup
            value={pairingStatusToggles}
            onChange={handlePairingStatusToggle}
            aria-label={PairingVerification.PairingVerificationStatus}
            className={classes.toggleButtonGroup}
          >
            {settingStates.pairingValidationStatus?.value.map((task) => {
              return (
                <ToggleButton key={task.text} value={task.text} aria-label={task.value} className={classes.toggleButton}>
                  {task.value}
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>
        </FormInputCollection>
      </div>
    );
  },
);
export default PairingVerificationStatusTabs;
